import { useState, useCallback } from 'react';

import usePipelineTagAutocomplete from 'app/shared/hooks/tags/usePipelineTagAutocomplete';
import sanitizeTagLabel from 'app/shared/helpers/tags/sanitizeTagLabel';

const STATIC_AUTOCOMPLETE_PROPS = {
  label: null,
  color: 'primary',
  placeholder: 'Add tag...',
  freeSolo: true,
  disableClearable: true,
  chipMaxWidth: 150,
};

export default function useEditableTagsAutocomplete({ pipelineId, currentTags, ChipProps }) {
  const { options, value, loading, handleChange } = usePipelineTagAutocomplete({
    pipelineId,
    currentTags,
  });

  const [inputValue, setInputValue] = useState('');

  const handleInputChange = useCallback((event, newInputValue) => {
    setInputValue(sanitizeTagLabel(newInputValue));
  }, []);

  return {
    onChange: handleChange,
    AutocompleteProps: {
      ...STATIC_AUTOCOMPLETE_PROPS,
      options,
      value,
      loading,
      ChipProps,
      inputValue,
      onInputChange: handleInputChange,
    },
  };
}
